import React from 'react';

export default function RadioButton({
  isActive,
  text,
  onClick,
  style,
  disabled,
}) {
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <div
      onClick={handleClick}
      className={`${style} ${
        isActive
          ? 'tw-bg-main tw-text-white tw-border-main-active'
          : 'tw-bg-input-background tw-border-input-border'
      } ${
        disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : 'tw-cursor-pointer'
      } tw-border-solid tw-border tw-rounded-lg tw-text-sm tw-px-3 tw-py-1.5 tw-mr-2`}
    >
      {text}
    </div>
  );
}
